import { ThemeUICSSObject } from 'theme-ui';
import primary from './primary';
import datagrid from './datagrid';
import secondary from './secondary';

const pagination: ThemeUICSSObject = {
  primary,
  datagrid,
  secondary,
};

export default pagination;
